<template>
    <div class="form-item">
        <label class="label-caption">{{ ckCombustivel ? 'Combustível' : 'Produto' }}</label>
        <select :value="produtoSelecionado" @change="atualizarObj" class="form-control" v-bind="$attrs"> 
            <option v-if="isLoading" disabled>Carregando...</option>
            <option v-if="!lsDados || lsDados.length === 0" disabled>Nenhuma opção disponível</option>
            <option v-for="obj in lsDados" :key="obj.id" :value="obj.id">{{ obj.nmproduto }}</option>
        </select>
    </div>
</template>

<script setup>
import { ref, watch, onMounted } from "vue";
import { genericPost } from "@/funcoes/api";
import { globalStore } from "@/globals";

const props = defineProps({
    ckAddTodos:{type: Boolean, default: false},
    ckCombustivel:{type: Boolean, default: false},
    ckIp:{type: Boolean, default: false},
    ckPesquisar: {type: Boolean, default: true},
    produtoSelecionado: {type: Number, default: null,},
});

const emit = defineEmits(["update:produtoSelecionado"]);
const lsDados = ref(null);
const isLoading = ref(false);

const fetchData = async () => {
    try {
        isLoading.value=true;
        const response = await genericPost('/listas/produtos', {
            idmunicipio: globalStore.idmunicipio, 
            ativo: 'S',
            strparam1: props.ckCombustivel ? 'S' : '',
            strparam2: props.ckIp ? 'S' : ''});
        lsDados.value = response;
        if (props.ckAddTodos){lsDados.value.unshift({ id: 0, nmproduto: 'TODOS' });}
    } catch (error) {console.error("Erro de conexão com a API:", error);
    }finally{isLoading.value=false;} 
};

const atualizarObj = (event) => {
    emit("update:produtoSelecionado", Number(event.target.value));
};

onMounted(() => {
    if (props.ckPesquisar){
        fetchData();
    }
});

watch(
    () => props.ckPesquisar,
    (newValue, oldValue) => {
        if (newValue && !oldValue) {fetchData();}
    }
);
</script>
  